'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.lottery = void 0;
var tslib_1 = require("tslib");
var adapter_1 = require("../adapter");
var Lottery = /** @class */ (function () {
    function Lottery() {
    }
    /**
     * Create a lottery bet
     */
    Lottery.prototype.createBet = function (params) {
        return adapter_1.adapter.lottery.createBet(params);
    };
    /**
     * Bulk buying bets
     */
    Lottery.prototype.bulkBuying = function (params) {
        return adapter_1.adapter.lottery.bulkBuying(params);
    };
    /**
     * This endpoint will return all of the draws which are open for bets to come in.
     * This call can either be called with the `lotteryId` or `countryCode` parameter so that
     * results are filtered by a product (e.g. only euromillions),
     * or without it which will return across all products.
     * Note that for RiSQ this does not necessarily mean that it is when the draw cycle is opened.
     * It will be driven by a separate 'flag' that will drive whether a draw is opened for bets or not.
     */
    Lottery.prototype.getOpenDraws = function (lotteryId, countryCode) {
        var params = {
            countryCode: countryCode,
            lotteryId: lotteryId,
        };
        return adapter_1.adapter.lottery.getOpenDraws(params);
    };
    /**
     * This endpoint will return all of the previous (past) draws
     * @param dateFrom - YYYY-MM-DD
     * @param dateTo - YYYY-MM-DD
     */
    Lottery.prototype.getPreviousDraws = function (dateFrom, dateTo) {
        var params = {
            dateFrom: dateFrom,
            dateTo: dateTo,
        };
        return adapter_1.adapter.lottery.getPreviousDraws(params);
    };
    /**
     * Returns the lottery providers
     */
    Lottery.prototype.getProviders = function () {
        return adapter_1.adapter.lottery.getProviders();
    };
    /**
     * Returns the user's bets
     * @param dateFrom - YYYY-MM-DD
     * @param dateTo - YYYY-MM-DD
     */
    Lottery.prototype.getUserBets = function (dateFrom, dateTo, betStatus) {
        var params = {
            dateFrom: dateFrom,
            dateTo: dateTo,
            betStatus: betStatus,
        };
        return adapter_1.adapter.lottery.getUserBets(params);
    };
    /**
     * Returns the results of the user's bets
     * @param dateFrom - YYYY-MM-DD
     * @param dateTo - YYYY-MM-DD
     */
    Lottery.prototype.getUserBetResults = function (dateFrom, dateTo, betStatus) {
        var params = {
            dateFrom: dateFrom,
            dateTo: dateTo,
            betStatus: betStatus,
        };
        return adapter_1.adapter.lottery.getUserBetResults(params);
    };
    /**
     * Returns the payout table for past draws
     */
    Lottery.prototype.getPayoutTable = function (drawId) {
        var params = {
            drawId: drawId,
        };
        return adapter_1.adapter.lottery.getPayoutTable(params);
    };
    /**
     * Returns the draw results (winning numbers) for a specified past draw
     */
    Lottery.prototype.getWinningNumbersForDraw = function (drawId) {
        var params = {
            drawId: drawId,
        };
        return adapter_1.adapter.lottery.getWinningNumbersForDraw(params);
    };
    /**
     * Fetch one lottery by lotteryId taking demographics into account
     */
    Lottery.prototype.get = function (lotteryId, demographic) {
        var params = tslib_1.__assign({ lotteryId: lotteryId }, demographic);
        return adapter_1.adapter.lottery.get(params);
    };
    /**
     * Fetch all available lottery taking demographics into account
     */
    Lottery.prototype.getAll = function (demographic) {
        return adapter_1.adapter.lottery.getAll(demographic);
    };
    /**
     * Creates a lottery subscription based on the chosen user number selection for the specific time interval.
     * Once subscription is created, unless it is canceled it will be renewed based on the time interval.
     */
    Lottery.prototype.subscribe = function (params) {
        return adapter_1.adapter.lottery.subscribe(params);
    };
    Lottery.prototype.unsubscribe = function (params) {
        return adapter_1.adapter.lottery.unsubscribe(params);
    };
    return Lottery;
}());
exports.lottery = new Lottery();
